import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TntArchivedToolService, TntToolService } from '../../tnt.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ArchiveTool } from '../../../../shared/model';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';


@Component({
  selector: 'app-archive-tools',
  templateUrl: './archive-tools.component.html',
  host: { 'style': 'width: 100%' },
  // styleUrls: ['./archive-tools.component.scss']
})
export class ArchiveToolsComponent implements OnInit {

  constructor(
    private service: TntArchivedToolService,
    private toolService: TntToolService,
    private formBuilder: FormBuilder,
    private CgpAlertDialogService: CgpAlertDialogService,
    private CgpConfirmationDialogService: CgpConfirmationDialogService,
    private CgpSnackbarService: CgpSnackbarService,
  ) { }

  private isNew: boolean = false;
  editDataItem: ArchiveTool;
  editForm = new FormControl({
    Id: new FormControl(),
    ToolNumber: new FormControl(),
    ToolDescription: new FormControl(),
    Ownername: new FormControl(),
    ArchivedDate: new FormControl("", Validators.required),
  });
  private pageNumber: number = 1;


  private columns: any[] = [
    {
      field: "ToolNumber",
      title: "Tool Number",
      sortable: false,
    },
    {
      field: "ToolDescription",
      title: "Description",
      sortable: false,
    },
    {
      field: "Ownername",
      title: "Owner",
      sortable: false,
    },
    {
      field: "ArchivedDate",
      title: "Archived Date",
      sortable: false,
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }

    }
  ]

  handleread = (force, dataItem, state) => {
    let page = state.skip ? (state.skip / state.take) + 1 : this.pageNumber;
    let pageSize: string = "?pageSize=" + state.take;
    let pageNumber: string = '&pageNumber=' + page
    // let orderBy: string = '&orderBy=' + ((state.sort && state.sort[0]) ? state.sort[0].field : 'ArchivedDate');

    let urlExtension = pageSize + pageNumber;
    return this.service.read(urlExtension, true)
      .then(data => {
        return <GridDataResult>{
          data: data.TntTools,
          total: data.RecordCount
        };
      })
      .catch(e => Promise.resolve([]));
  }


  handlearchive = (e, dataItem, service: TntArchivedToolService, Tool, callbackInputs) => {
    var self = this;
    this.CgpConfirmationDialogService.showConfirmationDialog({
      title: 'Restore Tool',
      message: 'Are you sure that you want to restore ' + dataItem.ToolNumber + '?',
      alert: 'danger',
      onYesClick: () => {
        self.toolService
          .save(dataItem, false, '/restore?toolId=' + dataItem.Id, false, false, false)
          .then(function (response) {
            self.grid.refresh(true);
            self.CgpSnackbarService.showSnackbar({
              message: "Tool has been restored",
              duration: 2000
            });
            self.CgpConfirmationDialogService.closeConfirmationDialog();
          }).catch(function (response) {
            self.service.loading.next(false);
            self.CgpAlertDialogService.showAlertDialog({
              title: 'Error',
              message: response._body.replace(/"/g, ''),
              alert: 'danger',
              closeLabel: 'Close',
            })
          });;
      },
      onNoClick: () => {
        this.CgpConfirmationDialogService.closeConfirmationDialog();
      }
    })


  };

  //This is how you refresh the page ^^ //


  CustomButtons = [
    {
      id: "handlearchive",
      class: "fa fa-share-square-o",
      callback: this.handlearchive,
      title: 'Restore Tool'
    }
  ];




  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: false,
      width: 65,
      custom: this.CustomButtons,
    },
    columns: this.columns,
    service: this.service,
    read: this.handleread,

  }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;


  ngOnInit(): void { }

  setModelHandler() {
    this.editDataItem = new ArchiveTool();
  }

}
